import { render, staticRenderFns } from "./OverviewOtherLabour.vue?vue&type=template&id=0b93c88f&scoped=true"
import script from "./OverviewOtherLabour.vue?vue&type=script&lang=js"
export * from "./OverviewOtherLabour.vue?vue&type=script&lang=js"
import style0 from "./OverviewOtherLabour.vue?vue&type=style&index=0&id=0b93c88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b93c88f",
  null
  
)

export default component.exports